angular.module('elfium').filter('elfiumFilter', function () {
    var passedFilter = function (filterValue, filteredValue) {
        return !filterValue || (angular.isDefined(filteredValue) && String(filteredValue).toLowerCase().includes(filterValue.toLowerCase()));
    };
    var passedFilterArray = function (filterValues, filteredValue) {
        var isValid;
        if (filterValues.length) {
            isValid = false
            for (var i = 0; i < filterValues.length; ++i) {
                if (passedFilter(filterValues[i], filteredValue)) {
                    isValid = true;
                    break;
                }
            }    
        } else {
            isValid = true;
        }        
        return isValid;
    };
    var passedFilters = function (filter, filtered) {
    	if (!filtered) {
    		return false;
    	}
    	var isValid = true;
     	angular.forEach(filter, function (value, key) {
            if (angular.isArray(value)) {
                isValid = isValid && passedFilterArray(value, filtered[key]);
            } else if (angular.isObject(value)) {
    			isValid = isValid && passedFilters(value, filtered[key]);
    		} else {
    			isValid = isValid && passedFilter(value, filtered[key]);
    		}
    	});
    	return isValid;
    };
    return function (inputArray, filters) {
    	var resultArray = [];
    	angular.forEach(inputArray, function (arrayValue) {
    		if (passedFilters(filters, arrayValue)) {
    			resultArray.push(arrayValue);
    		}
    	});
        return resultArray;
    };
});


// WEBPACK FOOTER //
// ./src/app/components/elfium/elfiumFilterFilter.ts